export enum PassosTutorial {
    inicio = 0 ,
    barraProgresso = 1,
    aderirBeneficio = 2,
    cadastrarColaborador = 3,
    cadastrarPedido = 4,
    concluido = 5
}

export enum PassosNomesTutorial {
    inicio = 'Inicio',
    barraProgresso = 'Barra de progresso',
    aderirBeneficio = 'Aderir incentivo',
    cadastrarColaborador = 'Cadastrar favorecido',
    cadastrarPedido = 'Cadastrar Pedido'

}
